export interface File {
  fileName: string;
  fileDataUrl: string;
}

export interface PersonalDocuments {
  selfie?: File;
  rg?: File;
  cpf?: File;
  highSchoolTranscript?: File;
  highSchoolDiploma?: File;
  enemGradeProof?: File;
}

export interface SponsorDocuments {
  selfieSponsor?: File;
  rgSponsor?: File;
  cpfSponsor?: File;
}

export interface DocumentsState {
  personalDocuments: PersonalDocuments;
  sponsorDocuments: SponsorDocuments;
}

const documentData: DocumentsState = {
  sponsorDocuments: {},
  personalDocuments: {},
};

export default documentData;
